import { render, staticRenderFns } from "./PrivacyFy.vue?vue&type=template&id=95f41038&scoped=true"
import script from "./PrivacyFy.vue?vue&type=script&lang=js"
export * from "./PrivacyFy.vue?vue&type=script&lang=js"
import style0 from "./PrivacyFy.vue?vue&type=style&index=0&id=95f41038&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f41038",
  null
  
)

export default component.exports